<template>
  <double-pane>
    <template v-slot:left-pane>
      <h3 class="text-center">Locations</h3>
      <div class="my-3 input-group">
        <div class="input-group-prepend">
          <span class="input-group-text" id="filter">
            <i class="fa fa-search"></i>
          </span>
        </div>
        <input
          v-model.trim="filter"
          @keyup="applyFilter()"
          class="form-control"
          aria-describedby="filter"
          placeholder="filter by name"
        />
      </div>
      <loading-panel :loading="loading" class="m-auto">
        <div v-for="(location, ind) in filteredLocations" :key="`${ind}_loc`">
          <h3>
            <button
              class="btn w-100"
              :class="location === selected ? 'btn-primary' : 'btn-outline-primary'"
              @click="() => selected = location"
            >{{location.title}}</button>
          </h3>
        </div>
      </loading-panel>
      <error-panel class="m-auto" :errors="errors"></error-panel>
    </template>
    <template v-slot:right-pane>
      <location :location="selected"></location>
    </template>
  </double-pane>
</template>

<script>
import Location from "@/components/Location";
import DoublePane from "@/layouts/DoublePane";

export default {
  name: "locations",
  components: {
    DoublePane,
    Location
  },
  data: () => ({
    loading: true,
    errors: [],
    filteredLocations: [],
    locations: [],
    selected: null,
    filter: ""
  }),
  methods: {
    applyFilter() {
      this.filteredLocations = this.locations.filter(location =>
        location.title.toLowerCase().includes(this.filter.toLowerCase())
      );
    }
  },
  async mounted() {
    try {
      this.loading = true;
      const response = await this.$web.getLocations();
      if (response.data.owned && response.data.owned.length > 0) {
        this.locations = response.data.owned;
        this.applyFilter();
      } else {
        this.errors = ["No locations found."];
      }
    } catch (err) {
      console.log(err);
      this.errors = ["An error occurred."];
    } finally {
      this.loading = false;
    }
  }
};
</script>

<style scoped>
.logo {
  max-width: 100%;
  max-height: 100%;
}
</style>
